import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import memoizeOne from 'memoize-one';
import isDeepEqual from 'lodash/isEqual';

function identity(value) {
  return value;
}

var deepMemoized = memoizeOne(identity, isDeepEqual);
export function isIndexRoute(leafRoute) {
  if (!leafRoute) {
    return true;
  } // A route that has itself (not a parent) a chapter,
  // is considered the top-level of that chapter, so is named 'default'.


  return !!(leafRoute.tracking && (leafRoute.tracking.chapter3 || leafRoute.tracking.chapter2 || leafRoute.tracking.chapter1));
}

function sanitizeName(name) {
  if (!name) {
    return 'default';
  }

  return name.replace(/\s/g, '_') || 'default';
}

function getName(value, params) {
  var paramIndex = value.search(':');

  if (paramIndex > -1) {
    var namedValue = params[value.slice(paramIndex + 1)];
    var fullValue = namedValue ? value.replace(/:[^/]+/, namedValue) : '';
    return sanitizeName(fullValue);
  }

  return sanitizeName(value);
}

var stripRouteParamsPattern = /(?:\(?\/:[^/]+\)?)/g;
var stripParentRoutePathPattern = /^(?:\/?.+\/)*/g;
export function extractSlug(allRoutes) {
  var routes = allRoutes.filter(function (route) {
    return route.path || route.tracking;
  });
  var leafRoute = routes[routes.length - 1];

  if (!leafRoute || leafRoute.path === '/' || isIndexRoute(leafRoute)) {
    return 'default';
  }

  var path = leafRoute.path || '';
  return sanitizeName(path.replace(stripRouteParamsPattern, '').replace(stripParentRoutePathPattern, ''));
}
export function getTrackingProps(routes) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var trackedRoutes = routes.filter(function (route) {
    return route.tracking && _Object$keys(route.tracking).length;
  });

  if (!trackedRoutes.length) {
    return undefined;
  } // Reduce the current route's tracking props from itself and its parents.


  var routesTrackingProps = trackedRoutes.reduce(function (prev, route) {
    var _route$tracking;

    return prev.prefix && (_route$tracking = route.tracking) !== null && _route$tracking !== void 0 && _route$tracking.prefix ? _objectSpread(_objectSpread(_objectSpread({}, prev), route.tracking), {}, {
      prefix: prev.prefix + route.tracking.prefix
    }) : _objectSpread(_objectSpread({}, prev), route.tracking);
  }, _Object$freeze({})); // If the current route is a param, replace it with its current value.
  // See examples in T84967.
  // $FlowFixMe[incompatible-exact]

  var trackingProps = _Object$assign.apply(Object, [{}].concat(_toConsumableArray(_Object$keys(routesTrackingProps).map(function (param) {
    // $FlowFixMe[prop-missing]
    var value = routesTrackingProps[param];
    value = typeof value === 'string' ? getName(value, params) : value;

    if (value === 'default' && param !== 'name') {
      return {};
    }

    return _defineProperty({}, param, value);
  }))));

  if (!trackingProps || trackingProps.noTrack) {
    return undefined;
  }

  if (!trackingProps.name) {
    trackingProps.name = extractSlug(routes);
  }

  if (trackingProps.prefix) {
    trackingProps.name = "".concat(trackingProps.prefix).concat(trackingProps.name);
    delete trackingProps.prefix;
  }

  return trackingProps;
}
export { deepMemoized };